
export default function AppleEmptyCallback(){
    return(
        <div></div>
    );
}